module.exports = __webpack_public_path__ + "static/media/ic-bath.74cf96e0.svg";